


























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from '../../../lib/abpbase'
class UserWechat{
    userNameOrEmailAddress:'';
    password:'';
    unionId:'';
    openId:'';
    nickName:'';
    headImgUrl:'';
}

@Component
export default class LinkUserWechatView extends AbpBase {
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:UserWechat, required: true}) params:UserWechat;
    modelTitleL: string = this.L("微信登录绑定");
    formRef: string = "linkuserwechatform";
    currentModel: UserWechat = new UserWechat();
    cancel(){
        (this.$refs[this.formRef] as any).resetFields();
        this.$emit('input',false);
    }
    save(){
         (this.$refs[this.formRef] as any).validate(async (valid:boolean)=>{
                if(valid){
                    var result=await this.$store.dispatch({
                        type:'app/wxlink',
                        data:this.currentModel
                    });
                    if(result.success){
                        this.$Message.info('微信绑定完成');
                        this.$emit('save-success');
                        (this.$refs[this.formRef] as any).resetFields();
                        this.$emit('input',false);
                    }
                    else{
                       this.$alert(result.message,'提示',{type:'info'});
                    } 
                }
            })
    }
    visibleChange(value){
        if(!value){
           this.$emit('input',value);
        }
        else{
            this.currentModel = new UserWechat();
            this.currentModel=this.params;
           (this.$refs[this.formRef] as any).resetFields();
        }
        
    }
    passwdRule={
        userNameOrEmailAddress: [
        { required: true, message: this.L('用户名不能为空'), trigger: 'blur' }
        ],
        password: [
        { required: true, message: this.L('密码不能为空'), trigger: 'blur' }
        ]
    }
}
